export class User {
  id: number = -1;
  guid?: string;
  username?: string = null;
  email?: string = null;
  displayname?: string = null;
  firstname?: string = null;
  lastname?: string = null;
  thumb?: string = null;
  haspic?: boolean = null;

  get isAuthenticated(): boolean {
    return (this.id !== -1);
  }

  constructor(data?: User) {
    if (data) {
      for (let property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.guid = data['guid'] !== undefined ? data['guid'] : (null as any);
      this.id = data['id'] !== undefined ? data['id'] : (null as any);
      this.username = data['username'] !== undefined ? data['username'] : (null as any);
      this.email = data['email'] !== undefined ? data['email'] : (null as any);
      this.displayname = data['displayname'] !== undefined ? data['displayname'] : (null as any);
      this.firstname = data['firstname'] !== undefined ? data['firstname'] : (null as any);
      this.lastname = data['lastname'] !== undefined ? data['lastname'] : (null as any);
      this.thumb = data['thumb'] !== undefined ? data['thumb'] : (null as any);
      this.haspic = data['haspic'] !== undefined ? data['haspic'] : (null as any);
    }
  }

  static fromJS(data: any): User {
    data = typeof data === 'object' ? data : {};
    const result = new User();
    result.init(data);
    return result;
  }
}
